import React, { Fragment } from 'react';
import './ErrorPage.css';

export const ErrorPage = () => (
  <Fragment>
    <div className='content'>
      <div className='wrapper pad'>
        <h1>Hoppla!!</h1>
        <p>Leider ist ein unerwarteter Fehler aufgetreten. Das hat leider nicht geklappt. Probiere es später noch einmal oder kontaktiere uns unter <a href='mailto:service@mcdonalds.de' className='mail-address'>service@mcdonalds.de</a></p>
      </div>
    </div>
  </Fragment>
);
